function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.alert0{fill:#FFFFFF;}\r\n\t.alert1{fill:#C4262E;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "alert0",
  d: "M465.5,340.9c-30.2-28.8-50.3-63.2-50.3-140.9c0-86-60.5-155.1-147.6-163.6v-16c0-9.5-13.1-18.3-28.3-18.3 c-15.5,0-25.3,7.7-25.3,17.3v16C127,43.9,63.5,112,63.5,198c0,88.3-18.1,118.1-48.3,146.9c-15.1,14.3-14.9,44-7.2,63.3 c7.9,19.7,24.8,33.4,46.2,33.4l101.2,0.2c0,0-2.3,98.3,82.5,98.3c94.5,0,87.4-97.8,87.4-97.8l100.2,0.3c21.4,0,39.4-14.7,47.2-34.4 C480.4,388.9,480.6,355.2,465.5,340.9z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "alert1",
  d: "M240.3,492.3c-17.7,0-32-14.4-32-32h-32c0,35.3,28.7,64,64,64s64-28.7,64-64h-32 C272.3,477.9,258,492.3,240.3,492.3z M449.7,347.1c-28-26.6-49.3-54.5-49.3-148.9c0-79.6-63.4-144.5-144-152.4V28.3 c0-8.8-7.2-16-16-16s-16,7.2-16,16v17.6c-80.7,7.9-144,72.8-144,152.3c0,94.4-21.4,122.3-49.3,148.9c-14,13.3-18.4,33.4-11.3,51.2 c7.3,18.2,24.8,30,44.6,30h352c19.8,0,37.4-11.8,44.6-30C468.1,380.5,463.7,360.4,449.7,347.1z M416.3,396.3h-352 c-14.2,0-21.3-16.5-11.3-26c34.9-33.2,59.3-70.3,59.3-172.1c0-67.4,57.3-121.9,128-121.9c70.8,0,128,54.5,128,121.9 c0,101.3,24.2,138.7,59.3,172.1C437.7,379.8,430.5,396.3,416.3,396.3z"
}));

const SvgIconAlert = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477.6 542.6",
    style: {
      enableBackground: "new 0 0 477.6 542.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-alert.1b4c63f6.svg";
export { ForwardRef as ReactComponent };